export const catalogueContributionsCopy = {
  en: {
    reportAlreadyPending:
      'You already reported this content and it is awaiting review. Follow its progress in Catalogue activity.',
    targets: {
      cover: 'Cover',
      description: 'Description',
      book: 'Book details and other concerns',
    },
    noReasons: 'No concerns selected',
    selectReason: 'Choose at least one reason before sending your report.',
    targetDetails: '{{target}}: explanation (optional)',
    reportPolicy:
      'Adult books are allowed and remain searchable. Pornographic cover imagery is prohibited. Safety reports temporarily hide the affected cover or description while moderators review the content and context. A report is an allegation: nudity, profanity or mature themes alone do not establish a violation.',
    reportHeld:
      'Temporarily unavailable pending review: {{targets}}. The book and your reading data remain available.',
    reportActivityHint: 'Follow the review and moderator’s response in Catalogue activity.',
    descriptionUnavailable: 'Description currently unavailable.',
    reportExpired:
      'This edition’s content needs refreshing. Return to the book or search again, then reopen the report.',
    reportRateLimit: 'You have sent several reports recently. Please wait before trying again.',
    reviewedComplaint:
      'This concern has already been reviewed. Explain genuinely new evidence to request another review; the same complaint will not hide the content again.',
    newEvidence: 'New evidence for the moderators',
    evidenceRequired: 'Describe the new evidence in at least 20 characters.',
    issueState: {
      visible: 'Available',
      held: 'Temporarily hidden during review',
      suppressed: 'Suppressed after review',
    },
    issueReasons: {
      explicit_sexual: 'Pornographic or explicit sexual imagery',
      offensive_text: 'Profane or offensive text on the cover',
      graphic_violence: 'Graphic or gory imagery',
      wrong_artwork: 'Wrong or unrelated artwork',
      offensive_language: 'Profane or offensive language',
      hateful_content: 'Hateful or discriminatory content',
      graphic_content: 'Graphic sexual or violent content',
      inaccurate: 'Inaccurate or unrelated information',
      metadata: 'Incorrect book details',
      duplicate: 'Duplicate book',
      wrong_edition: 'Wrong edition',
      inappropriate: 'Other inappropriate content',
      rights: 'Rights or copyright concern',
    },
    metadataLabels: {
      language: 'Book language',
      isbn: 'ISBN',
      publisher: 'Publisher',
      year: 'Publication year',
      pages: 'Number of pages',
      binding: 'Binding',
      description: 'Description',
    },
    activityIntro: 'Follow your submissions and updates from the moderation team.',
    activityError: 'Your activity could not be refreshed. Please try again.',
    emptyHelp:
      'Suggest a private book for the shared catalogue or report a problem with an existing edition. You’ll see its progress here.',
    moderatorNote: 'From the moderation team',
    openSubmission: 'View submission',
    activity: 'Catalogue activity',
    submissions: 'Your submissions',
    reports: 'Your reports',
    empty: 'No catalogue activity yet.',
    reviewStatus: { pending: 'Awaiting review', resolved: 'Resolved', dismissed: 'Dismissed' },
    suggest: 'Suggest for shared catalogue',
    report: 'Report a problem',
    title: 'Share this edition',
    privacy:
      'Moderators may correct or complete these bibliographic details before publication. Approval upgrades this book in your library and preserves your reading data. The book’s quotes can then enter moderation without your name. Your progress, dates, notes, personal thoughts, ratings and reviews are not published.',
    consent: 'I agree to publish these bibliographic details in the shared catalogue.',
    titleField: 'Title',
    subtitle: 'Subtitle (optional)',
    authors: 'Authors (one per line)',
    unknown: 'The author is unknown',
    language: 'Book language',
    chooseLanguage: 'Choose a language',
    isbn: 'ISBN (optional)',
    publisher: 'Publisher (optional)',
    year: 'Publication year (optional)',
    pages: 'Number of pages (optional)',
    binding: 'Binding (optional)',
    description: 'Description (optional)',
    none: 'Not specified',
    preview: 'Preview publication',
    edit: 'Edit details',
    submit: 'Send for review',
    resubmit: 'Resubmit for review',
    withdraw: 'Withdraw submission',
    refresh: 'Refresh status',
    connect: 'Connect my book to this edition',
    open: 'View catalogue edition',
    matched:
      'A moderator found this existing edition. Review it before connecting your book. Your reading data will be preserved. If this edition is already in your library, connecting will stop without merging entries.',
    validation:
      'Enter a title, authors or unknown author, and choose a language. Check the optional ISBN, page count and year.',
    error: 'This action could not be completed. Try again with the same details.',
    conflict:
      'The submission or library has changed. Refresh its status before continuing. Existing library entries have not been merged.',
    unavailable: 'This action is not available for this book.',
    loading: 'Loading catalogue details…',
    signIn: 'Sign in to contribute to the catalogue.',
    privateBook: {
      title: 'Private book',
      onlyYou: 'Only you can see it',
      goodreads: 'Imported from Goodreads · only you can see it',
      body: 'Missing from the Belore catalogue? Suggest it, and once a moderator approves it, other readers can find it too.',
      suggest: 'Suggest for the catalogue',
      fine: 'Only the edition details are shared. Your reading and notes stay private.',
      pendingBody:
        'Sent to the moderators on {{date}}. Until they approve it, the book stays private.',
      changesBody: 'The moderators asked for a few changes before publishing.',
      changesAction: 'Edit submission',
      matchedBody:
        'The moderators found this edition in the catalogue already. Connect your book to it; your reading stays as it is.',
      matchedAction: 'View edition and connect',
      declinedBody: 'The book stays private in your library.',
    },
    status: {
      pending: 'Awaiting review',
      changes_requested: 'Changes requested',
      declined: 'Declined',
      withdrawn: 'Withdrawn',
      published: 'Published',
      matched: 'Existing edition found',
    },
    reason: 'What is the problem?',
    details: 'Additional details (optional)',
    duplicate: 'Duplicate edition ID (optional)',
    sent: 'Report sent. A moderator will review it.',
    sendReport: 'Send report',
    reportIntro:
      'Report a problem with this shared edition. Your report is private to the moderation team.',
    reasons: {
      metadata: 'Incorrect metadata',
      duplicate: 'Duplicate book',
      wrong_edition: 'Wrong edition',
      inappropriate: 'Inappropriate content',
      cover: 'Cover problem',
      rights: 'Rights concern',
    },
  },
  sk: {
    reportAlreadyPending:
      'Tento obsah ste už nahlásili a čaká na kontrolu. Priebeh nájdete v Aktivite v katalógu.',
    targets: {
      cover: 'Obálka',
      description: 'Popis',
      book: 'Údaje o knihe a ďalšie problémy',
    },
    noReasons: 'Žiadny vybraný problém',
    selectReason: 'Pred odoslaním hlásenia vyberte aspoň jeden dôvod.',
    targetDetails: '{{target}}: vysvetlenie (nepovinné)',
    reportPolicy:
      'Knihy pre dospelých sú povolené a ostávajú vyhľadateľné. Pornografické obrázky na obálkach sú zakázané. Hlásenie týkajúce sa bezpečnosti dočasne skryje príslušnú obálku alebo popis, kým moderátori posúdia obsah a kontext. Hlásenie je podnet, nie dôkaz: nahota, vulgarizmy ani témy pre dospelých samy osebe neznamenajú porušenie pravidiel.',
    reportHeld:
      'Dočasne nedostupné počas kontroly: {{targets}}. Kniha aj údaje o vašom čítaní ostávajú dostupné.',
    reportActivityHint: 'Priebeh kontroly a odpoveď moderátora nájdete v Aktivite v katalógu.',
    descriptionUnavailable: 'Popis je momentálne nedostupný.',
    reportExpired:
      'Obsah tohto vydania treba obnoviť. Vráťte sa ku knihe alebo zopakujte vyhľadávanie a hlásenie otvorte znova.',
    reportRateLimit: 'Nedávno ste odoslali viacero hlásení. Pred ďalším pokusom chvíľu počkajte.',
    reviewedComplaint:
      'Tento podnet už bol posúdený. Pre ďalšiu kontrolu opíšte nové dôkazy; rovnaké hlásenie obsah opäť neskryje.',
    newEvidence: 'Nové dôkazy pre moderátorov',
    evidenceRequired: 'Opíšte nové dôkazy aspoň 20 znakmi.',
    issueState: {
      visible: 'Dostupné',
      held: 'Dočasne skryté počas kontroly',
      suppressed: 'Skryté po posúdení',
    },
    issueReasons: {
      explicit_sexual: 'Pornografické alebo explicitné sexuálne obrázky',
      offensive_text: 'Vulgárny alebo urážlivý text na obálke',
      graphic_violence: 'Explicitné alebo krvavé obrázky',
      wrong_artwork: 'Nesprávna alebo nesúvisiaca obálka',
      offensive_language: 'Vulgárny alebo urážlivý jazyk',
      hateful_content: 'Nenávistný alebo diskriminačný obsah',
      graphic_content: 'Explicitný sexuálny alebo násilný obsah',
      inaccurate: 'Nesprávne alebo nesúvisiace informácie',
      metadata: 'Nesprávne údaje o knihe',
      duplicate: 'Duplicitná kniha',
      wrong_edition: 'Nesprávne vydanie',
      inappropriate: 'Iný nevhodný obsah',
      rights: 'Problém s právami alebo autorskými právami',
    },
    metadataLabels: {
      language: 'Jazyk knihy',
      isbn: 'ISBN',
      publisher: 'Vydavateľ',
      year: 'Rok vydania',
      pages: 'Počet strán',
      binding: 'Väzba',
      description: 'Popis',
    },
    activityIntro: 'Sledujte svoje návrhy a správy od moderátorského tímu.',
    activityError: 'Aktivitu sa nepodarilo obnoviť. Skúste to znova.',
    emptyHelp:
      'Navrhnite súkromnú knihu do spoločného katalógu alebo nahláste problém s existujúcim vydaním. Priebeh kontroly uvidíte tu.',
    moderatorNote: 'Od moderátorského tímu',
    openSubmission: 'Zobraziť návrh',
    activity: 'Aktivita v katalógu',
    submissions: 'Vaše návrhy',
    reports: 'Vaše hlásenia',
    empty: 'Zatiaľ žiadna aktivita v katalógu.',
    reviewStatus: { pending: 'Čaká na kontrolu', resolved: 'Vyriešené', dismissed: 'Zamietnuté' },
    suggest: 'Navrhnúť do spoločného katalógu',
    report: 'Nahlásiť problém',
    title: 'Zdieľať toto vydanie',
    privacy:
      'Moderátori môžu tieto bibliografické údaje pred zverejnením opraviť alebo doplniť. Schválením sa aktualizuje táto kniha vo vašej knižnici a zachovajú sa vaše údaje o čítaní. Citáty z knihy potom môžu prejsť na posúdenie bez uvedenia vášho mena. Priebeh čítania, dátumy, poznámky, osobné myšlienky, hodnotenia a recenzie sa nezverejnia.',
    consent: 'Súhlasím so zverejnením týchto bibliografických údajov v spoločnom katalógu.',
    titleField: 'Názov',
    subtitle: 'Podnázov (nepovinné)',
    authors: 'Autori (každý na samostatnom riadku)',
    unknown: 'Autor je neznámy',
    language: 'Jazyk knihy',
    chooseLanguage: 'Vyberte jazyk',
    isbn: 'ISBN (nepovinné)',
    publisher: 'Vydavateľ (nepovinné)',
    year: 'Rok vydania (nepovinné)',
    pages: 'Počet strán (nepovinné)',
    binding: 'Väzba (nepovinné)',
    description: 'Popis (nepovinné)',
    none: 'Neuvedené',
    preview: 'Náhľad zverejnenia',
    edit: 'Upraviť údaje',
    submit: 'Odoslať na kontrolu',
    resubmit: 'Znovu odoslať na kontrolu',
    withdraw: 'Stiahnuť návrh',
    refresh: 'Obnoviť stav',
    connect: 'Prepojiť moju knihu s týmto vydaním',
    open: 'Zobraziť vydanie v katalógu',
    matched:
      'Moderátor našiel toto existujúce vydanie. Pred prepojením ho skontrolujte. Údaje o čítaní sa zachovajú. Ak už máte toto vydanie v knižnici, prepojenie sa zastaví bez zlúčenia záznamov.',
    validation:
      'Vyplňte názov, autorov alebo neznámeho autora a vyberte jazyk. Skontrolujte nepovinné ISBN, počet strán a rok.',
    error: 'Akciu sa nepodarilo dokončiť. Skúste to znova s rovnakými údajmi.',
    conflict:
      'Návrh alebo knižnica sa zmenili. Pred pokračovaním obnovte stav. Existujúce záznamy knižnice neboli zlúčené.',
    unavailable: 'Táto akcia nie je pre túto knihu dostupná.',
    loading: 'Načítavajú sa údaje katalógu…',
    signIn: 'Ak chcete prispieť do katalógu, prihláste sa.',
    privateBook: {
      title: 'Súkromná kniha',
      onlyYou: 'Vidíš ju len ty',
      goodreads: 'Importovaná z Goodreads · vidíš ju len ty',
      body: 'Chýba v katalógu Belore? Navrhni ju a po schválení ju nájdu aj ostatní čitatelia.',
      suggest: 'Navrhnúť do katalógu',
      fine: 'Zverejnia sa len údaje o vydaní. Tvoje čítanie a poznámky ostávajú súkromné.',
      pendingBody: 'Návrh je u moderátorov od {{date}}. Kým ho neschvália, kniha ostáva súkromná.',
      changesBody: 'Moderátori pred zverejnením žiadajú pár úprav.',
      changesAction: 'Upraviť návrh',
      matchedBody:
        'Moderátori našli toto vydanie už v katalógu. Prepoj s ním svoju knihu, tvoje čítanie ostane zachované.',
      matchedAction: 'Pozrieť vydanie a prepojiť',
      declinedBody: 'Kniha ostáva súkromná v tvojej knižnici.',
    },
    status: {
      pending: 'Čaká na kontrolu',
      changes_requested: 'Požadované úpravy',
      declined: 'Zamietnuté',
      withdrawn: 'Stiahnuté',
      published: 'Zverejnené',
      matched: 'Našlo sa existujúce vydanie',
    },
    reason: 'Aký je problém?',
    details: 'Ďalšie podrobnosti (nepovinné)',
    duplicate: 'ID duplicitného vydania (nepovinné)',
    sent: 'Hlásenie bolo odoslané. Skontroluje ho moderátor.',
    sendReport: 'Odoslať hlásenie',
    reportIntro: 'Nahláste problém s týmto spoločným vydaním. Hlásenie uvidí iba moderátorský tím.',
    reasons: {
      metadata: 'Nesprávne údaje',
      duplicate: 'Duplicitná kniha',
      wrong_edition: 'Nesprávne vydanie',
      inappropriate: 'Nevhodný obsah',
      cover: 'Problém s obálkou',
      rights: 'Problém s právami',
    },
  },
  cs: {
    reportAlreadyPending:
      'Tento obsah jste již nahlásili a čeká na kontrolu. Průběh najdete v Aktivitě v katalogu.',
    targets: {
      cover: 'Obálka',
      description: 'Popis',
      book: 'Údaje o knize a další problémy',
    },
    noReasons: 'Žádný vybraný problém',
    selectReason: 'Před odesláním hlášení vyberte alespoň jeden důvod.',
    targetDetails: '{{target}}: vysvětlení (nepovinné)',
    reportPolicy:
      'Knihy pro dospělé jsou povolené a zůstávají vyhledatelné. Pornografické obrázky na obálkách jsou zakázané. Hlášení týkající se bezpečnosti dočasně skryje příslušnou obálku nebo popis, než moderátoři posoudí obsah a kontext. Hlášení je podnět, ne důkaz: nahota, vulgarismy ani témata pro dospělé sama o sobě neznamenají porušení pravidel.',
    reportHeld:
      'Dočasně nedostupné během kontroly: {{targets}}. Kniha i údaje o vašem čtení zůstávají dostupné.',
    reportActivityHint: 'Průběh kontroly a odpověď moderátora najdete v Aktivitě v katalogu.',
    descriptionUnavailable: 'Popis je momentálně nedostupný.',
    reportExpired:
      'Obsah tohoto vydání je třeba obnovit. Vraťte se ke knize nebo zopakujte vyhledávání a hlášení otevřete znovu.',
    reportRateLimit: 'Nedávno jste odeslali několik hlášení. Před dalším pokusem chvíli počkejte.',
    reviewedComplaint:
      'Tento podnět již byl posouzen. Pro další kontrolu popište nové důkazy; stejné hlášení obsah znovu neskryje.',
    newEvidence: 'Nové důkazy pro moderátory',
    evidenceRequired: 'Popište nové důkazy alespoň 20 znaky.',
    issueState: {
      visible: 'Dostupné',
      held: 'Dočasně skryté během kontroly',
      suppressed: 'Skryté po posouzení',
    },
    issueReasons: {
      explicit_sexual: 'Pornografické nebo explicitní sexuální obrázky',
      offensive_text: 'Vulgární nebo urážlivý text na obálce',
      graphic_violence: 'Explicitní nebo krvavé obrázky',
      wrong_artwork: 'Nesprávná nebo nesouvisející obálka',
      offensive_language: 'Vulgární nebo urážlivý jazyk',
      hateful_content: 'Nenávistný nebo diskriminační obsah',
      graphic_content: 'Explicitní sexuální nebo násilný obsah',
      inaccurate: 'Nesprávné nebo nesouvisející informace',
      metadata: 'Nesprávné údaje o knize',
      duplicate: 'Duplicitní kniha',
      wrong_edition: 'Nesprávné vydání',
      inappropriate: 'Jiný nevhodný obsah',
      rights: 'Problém s právy nebo autorskými právy',
    },
    metadataLabels: {
      language: 'Jazyk knihy',
      isbn: 'ISBN',
      publisher: 'Nakladatel',
      year: 'Rok vydání',
      pages: 'Počet stran',
      binding: 'Vazba',
      description: 'Popis',
    },
    activityIntro: 'Sledujte své návrhy a zprávy od moderátorského týmu.',
    activityError: 'Aktivitu se nepodařilo obnovit. Zkuste to znovu.',
    emptyHelp:
      'Navrhněte soukromou knihu do společného katalogu nebo nahlaste problém s existujícím vydáním. Průběh kontroly uvidíte zde.',
    moderatorNote: 'Od moderátorského týmu',
    openSubmission: 'Zobrazit návrh',
    activity: 'Aktivita v katalogu',
    submissions: 'Vaše návrhy',
    reports: 'Vaše hlášení',
    empty: 'Zatím žádná aktivita v katalogu.',
    reviewStatus: { pending: 'Čeká na kontrolu', resolved: 'Vyřešeno', dismissed: 'Zamítnuto' },
    suggest: 'Navrhnout do společného katalogu',
    report: 'Nahlásit problém',
    title: 'Sdílet toto vydání',
    privacy:
      'Moderátoři mohou tyto bibliografické údaje před zveřejněním opravit nebo doplnit. Schválením se aktualizuje tato kniha ve vaší knihovně a zachovají se vaše údaje o čtení. Citáty z knihy pak mohou přejít k posouzení bez uvedení vašeho jména. Průběh čtení, data, poznámky, osobní myšlenky, hodnocení a recenze se nezveřejní.',
    consent: 'Souhlasím se zveřejněním těchto bibliografických údajů ve společném katalogu.',
    titleField: 'Název',
    subtitle: 'Podnázev (nepovinné)',
    authors: 'Autoři (každý na samostatném řádku)',
    unknown: 'Autor je neznámý',
    language: 'Jazyk knihy',
    chooseLanguage: 'Vyberte jazyk',
    isbn: 'ISBN (nepovinné)',
    publisher: 'Nakladatel (nepovinné)',
    year: 'Rok vydání (nepovinné)',
    pages: 'Počet stran (nepovinné)',
    binding: 'Vazba (nepovinné)',
    description: 'Popis (nepovinné)',
    none: 'Neuvedeno',
    preview: 'Náhled zveřejnění',
    edit: 'Upravit údaje',
    submit: 'Odeslat ke kontrole',
    resubmit: 'Znovu odeslat ke kontrole',
    withdraw: 'Stáhnout návrh',
    refresh: 'Obnovit stav',
    connect: 'Propojit mou knihu s tímto vydáním',
    open: 'Zobrazit vydání v katalogu',
    matched:
      'Moderátor našel toto existující vydání. Před propojením ho zkontrolujte. Údaje o čtení se zachovají. Pokud již máte toto vydání v knihovně, propojení se zastaví bez sloučení záznamů.',
    validation:
      'Vyplňte název, autory nebo neznámého autora a vyberte jazyk. Zkontrolujte nepovinné ISBN, počet stran a rok.',
    error: 'Akci se nepodařilo dokončit. Zkuste to znovu se stejnými údaji.',
    conflict:
      'Návrh nebo knihovna se změnily. Před pokračováním obnovte stav. Existující záznamy knihovny nebyly sloučeny.',
    unavailable: 'Tato akce není pro tuto knihu dostupná.',
    loading: 'Načítají se údaje katalogu…',
    signIn: 'Chcete-li přispět do katalogu, přihlaste se.',
    privateBook: {
      title: 'Soukromá kniha',
      onlyYou: 'Vidíš ji jen ty',
      goodreads: 'Importovaná z Goodreads · vidíš ji jen ty',
      body: 'Chybí v katalogu Belore? Navrhni ji a po schválení ji najdou i ostatní čtenáři.',
      suggest: 'Navrhnout do katalogu',
      fine: 'Zveřejní se jen údaje o vydání. Tvoje čtení a poznámky zůstávají soukromé.',
      pendingBody: 'Návrh je u moderátorů od {{date}}. Dokud ho neschválí, kniha zůstává soukromá.',
      changesBody: 'Moderátoři před zveřejněním žádají pár úprav.',
      changesAction: 'Upravit návrh',
      matchedBody:
        'Moderátoři našli toto vydání už v katalogu. Propoj s ním svou knihu, tvoje čtení zůstane zachované.',
      matchedAction: 'Zobrazit vydání a propojit',
      declinedBody: 'Kniha zůstává soukromá ve tvé knihovně.',
    },
    status: {
      pending: 'Čeká na kontrolu',
      changes_requested: 'Požadované úpravy',
      declined: 'Zamítnuto',
      withdrawn: 'Staženo',
      published: 'Zveřejněno',
      matched: 'Nalezeno existující vydání',
    },
    reason: 'Jaký je problém?',
    details: 'Další podrobnosti (nepovinné)',
    duplicate: 'ID duplicitního vydání (nepovinné)',
    sent: 'Hlášení bylo odesláno. Zkontroluje ho moderátor.',
    sendReport: 'Odeslat hlášení',
    reportIntro:
      'Nahlaste problém s tímto společným vydáním. Hlášení uvidí pouze moderátorský tým.',
    reasons: {
      metadata: 'Nesprávné údaje',
      duplicate: 'Duplicitní kniha',
      wrong_edition: 'Nesprávné vydání',
      inappropriate: 'Nevhodný obsah',
      cover: 'Problém s obálkou',
      rights: 'Problém s právy',
    },
  },
};
